import React from 'react'
//Components
import {ActivityIndicator, Animated, FlatList, TextInput, View} from 'react-native'
import {Header, Label, Ripple} from "components/src/components";
//Third party
import Provider from "@ant-design/react-native/lib/provider";
import enUS from '@ant-design/react-native/lib/locale-provider/en_US';
import debounce from 'lodash.debounce';
//redux
import {logout, setToken, setUser} from "components/src/redux/action";
import {connect} from "react-redux";
//Network
import {Query} from "@apollo/react-components";

//Utils
import {Color, CommonStyle, Icon, IS_WEB, Strings, ThemeUtils} from "components/src/utils";
import {styles} from './styles.js';


class Search extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
            searchValue: '',
        }
        this.scrollY = new Animated.Value(0)
        this.changeText = debounce(() => {
            this.setState((state) => ({searchValue: state.searchText}))
        }, 500)
    }


    render() {
        const {searchText, searchValue} = this.state
        return (
            <Provider locale={enUS}>
                <Header style={CommonStyle.blankHeader}
                        onPressLeft={this.props.onClose}/>

                <View style={styles.container}>
                    <View style={styles.topContainer}>
                        <View style={styles.titleContainer}>
                            <Label xlarge
                                   font_medium
                                   mt={15}

                                   mb={15}
                                   align={'left'}>
                                {Strings.search}
                            </Label>

                        </View>
                    </View>


                    <View style={styles.SearchMainView}>


                        <Icon name={'search'}
                              color={Color.PRIMARY}
                              size={ThemeUtils.fontSmall}/>


                        <TextInput style={[styles.Textinput, IS_WEB ? {outline: 'none'} : null]}
                                   onChangeText={(text) => {
                                       this.setState({searchText: text}, () => {
                                           this.changeText()
                                       })
                                   }}
                                   placeholderTextColor={Color.PRIMARY}
                                   value={searchText}
                                   placeholder={Strings.search}/>
                        {searchText ?
                            (<Ripple style={styles.closeIconView}
                                     onPress={() => this.setState({
                                         searchText: '',
                                         searchValue: ''
                                     })}
                                     rippleContainerBorderRadius={20}>
                                <Icon name={'close'}
                                      size={ThemeUtils.fontXSmall}
                                      color={Color.PRIMARY} align={'right'}/>
                            </Ripple>) : null}

                    </View>


                    <Query query={this.props.query}
                           variables={{
                               ...this.props.variables,
                               key: searchValue
                           }}>
                        {({data, loading, error, fetchMore}) => {
                            if (loading) {
                                return (<ActivityIndicator color={Color.PRIMARY}
                                                           style={CommonStyle.loader}/>)
                            }
                            return (
                                <View>
                                    <FlatList data={data?.moovin_property_list?.data ?? []}
                                              renderItem={this.props.renderItem}/>

                                </View>

                            )
                        }}
                    </Query>


                </View>

            </Provider>
        );
    }
}

const mapStateToProps = (state) => {
    if (state === undefined) {
        return {};
    }
    return {
        token: state.token,
        user: state.user || {},
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setUser: (user) => dispatch(setUser(user)),
        setToken: (token) => dispatch(setToken(token)),
        logout: () => dispatch(logout())
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Search);
